import '../globalThisPolyfill.js';
import '../../../../../es6/shared/cookie.js.es6';
import '../../../../../es6/shared/jquery-safe-selectors.js.es6';
import '../../../../../es6/shared/user-data.js.es6';
import '../../../../../es6/shared/timezones.js.es6';
import '../../../../../es6/shared/preload.js.es6';
import '../../../../../es6/shared/raf.es6';
import '../../../../../es6/shared/random.js.es6';
import '../../../../../es6/shared/ab-tests-helper.js.es6';
import '../../../../../es6/shared/setup.js.es6';
import '../../../../../es6/shared/debug.js.es6';
import '../../../../../es6/shared/log.js.es6';
import '../../../../../es6/shared/track.js.es6';
import '../../../../../es6/shared/performance-tracker.js.es6';
import '../../../../../components/locale-links.js.es6';
import '../../../../../components/locale-manager.js.es6';
import '../../../../../components/locale-auto-set.js.es6';
import '../../../../../components/web-vitals.js.es6';

import { preloadRoomCardHoverInteractions } from '@/services/room-card-prefetcher';

preloadRoomCardHoverInteractions();
